import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import * as XLSX from 'xlsx';
import {
  Row, Col, Card, Table, Button, Input,
  notification, Modal, Select, Typography,
  Checkbox, DatePicker, Drawer, Form, Tooltip, Avatar, Image, Space, Tag, Spin
} from "antd";
import axios from "axios";
import { baseUrl } from "../../config";
import {
  DeleteOutlined, FileExcelOutlined,
  FilterOutlined, EditOutlined, ExclamationCircleOutlined, PlusOutlined, UserOutlined,
  PhoneOutlined, CalendarOutlined, ReloadOutlined, CloseOutlined, SearchOutlined,
  TeamOutlined
} from "@ant-design/icons";
import userDummy from "../../assets/images/dummy-user.png";
import { getPermissions, hasPermission } from '../../components/permissions';
import '../../assets/styles/custom_style.css';
import moment from 'moment';
import VisheshSahyogiForm from './Form';
import AddMessage from "./components/purnimaForm";
import AddImageForm from "./components/purnimaFormWithImg";
import ImportListModal from './components/importListModal';

const { confirm } = Modal;
const { Option } = Select;
const { Title, Text } = Typography;

function VisheshSahyogi() {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const currentPageQuery = parseInt(queryParams.get('page')) || 1;
  const limitQuery = parseInt(queryParams.get('limit')) || 20;

  const [visheshSahyogiList, setVisheshSahyogiList] = useState([]);
  const [pagination, setPagination] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(limitQuery);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [purnimaSettingRecord, setPurnimaSettingRecord] = useState();
  
  const [filters, setFilters] = useState({
    name: queryParams.get('name') || '',
    phone_no: queryParams.get('phone_no') || '',
    order_key: queryParams.get('order_key') || '',
    father_name: queryParams.get('father_name') || '',
    father_in_low: queryParams.get('father_in_low') || '',
    gotra: queryParams.get('gotra') || '',
    village: queryParams.get('village') || '',
    tehsil: queryParams.get('tehsil') || '',
    district: queryParams.get('district') || '',
    occupation: queryParams.get('occupation') || '',
    occ_district: queryParams.get('occ_district') || '',
    amount_pledge: queryParams.get('amount_pledge') || '',
    alternative_no: queryParams.get('alternative_no') || '',
    committee: queryParams.get('committee') || '',
    meeting_attendance: queryParams.get('meeting_attendance') || '',
    meeting_remark: queryParams.get('meeting_remark') || '',
    meeting_date: queryParams.get('meeting_date') || '',
    dob: queryParams.get('dob') || '',
    createdAt: queryParams.get('createdAt') || '',
  });

  // Drawer states
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  // Filter and modal states
  const [showVisheshFilter, setShowVisheshFilter] = useState(true);
  const [showPurnimaMessageForm, setShowPurnimaMessageForm] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisibleImportList, setIsModalVisibleImportList] = useState(false);
  const [currentImage, setCurrentImage] = useState("");

  // Enhanced table columns with better styling
  const columns = [
    {
      title: <Text strong style={{ color: '#7a0000' }}>#</Text>,
      dataIndex: "key",
      key: "key",
      fixed: 'left',
      width: 60,
      align: 'center',
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Photo</Text>,
      dataIndex: "photo",
      key: "photo",
      fixed: 'left',
      width: 80,
      align: 'center',
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Phone No</Text>,
      dataIndex: "phone_no",
      key: "phone_no",
      fixed: 'left',
      width: 140,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Order</Text>,
      dataIndex: "order_key",
      key: "order_key",
      width: 80,
      align: 'center',
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Name</Text>,
      dataIndex: "name",
      key: "name",
      width: 150,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Amount</Text>,
      dataIndex: "amount_pledge",
      key: "amount_pledge",
      width: 120,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Father Name</Text>,
      dataIndex: 'father_name',
      key: 'father_name',
      width: 150,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Father In Law</Text>,
      dataIndex: 'father_in_low',
      key: 'father_in_low',
      width: 150,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Gotra</Text>,
      dataIndex: 'gotra',
      key: 'gotra',
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Village</Text>,
      dataIndex: "village",
      key: "village",
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Tehsil</Text>,
      dataIndex: "tehsil",
      key: "tehsil",
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>District</Text>,
      dataIndex: "district",
      key: "district",
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Occupation</Text>,
      dataIndex: "occupation",
      key: "occupation",
      width: 130,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Occ District</Text>,
      dataIndex: "occ_district",
      key: "occ_district",
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Contribution</Text>,
      dataIndex: "inspiration_remark",
      key: "inspiration_remark",
      width: 150,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Alt. No</Text>,
      dataIndex: "alternative_no",
      key: "alternative_no",
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>DOB</Text>,
      dataIndex: "dob",
      key: "dob",
      width: 120,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Committee</Text>,
      dataIndex: "committee",
      key: "committee",
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Meeting Attend</Text>,
      dataIndex: "meeting_attendance",
      key: "meeting_attendance",
      width: 130,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Meeting Remark</Text>,
      dataIndex: "meeting_remark",
      key: "meeting_remark",
      width: 150,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Meeting Date</Text>,
      dataIndex: "meeting_date",
      key: "meeting_date",
      width: 120,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Entry Date</Text>,
      dataIndex: "createdAt",
      key: "createdAt",
      width: 120,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Actions</Text>,
      key: "action",
      dataIndex: "action",
      fixed: 'right',
      width: 120,
      align: 'center',
    }
  ];

  useEffect(() => {
    const { state } = history.location;
    const restoredPage = state?.page || currentPage;
    const restoredLimit = state?.limit || limit;
    getVisheshSahyogiList(restoredPage, restoredLimit, sortField, sortOrder, search, filters);
  }, [history.location]);

  // Drawer functions
  const showDrawer = (userId = null) => {
    setCurrentUserId(userId);
    setIsUpdateMode(!!userId);
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
    setCurrentUserId(null);
    setIsUpdateMode(false);
  };

  const onRefresh = () => {
    closeDrawer();
    getVisheshSahyogiList(currentPage, limit, sortField, sortOrder, search, filters);
  };

  async function getVisheshSahyogiList(page = 1, limit = 20, sortField = null, sortOrder = null, search = '', filters = {}) {
    try {
      setLoading(true);
      setCurrentPage(page);
      setLimit(limit);
      const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
      const searchParam = search ? `&search=${search}` : '';
      const filterParams = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&');
      const response = await axios.get(`${baseUrl}/vishesh_sahyogi/list?page=${page}&limit=${limit}${sortParam}${searchParam}&${filterParams}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        setVisheshSahyogiList(response.data.result);
        setPagination({
          current: page,
          pageSize: limit,
          total: response.data.totalCount
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to fetch Vishesh Sahyogi data',
        placement: 'topRight'
      });
    } finally {
      setLoading(false);
    }
  }

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`${baseUrl}/vishesh_sahyogi/delete/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      if (response.status === 200) {
        getVisheshSahyogiList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
        notification.success({
          message: 'Success',
          description: 'Vishesh Sahyogi deleted successfully!',
          placement: 'topRight'
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to delete Vishesh Sahyogi',
        placement: 'topRight'
      });
    }
  };

  const showDeleteConfirm = (id, userName) => {
    confirm({
      title: 'Delete Vishesh Sahyogi',
      icon: <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />,
      content: (
        <div>
          <p>Are you sure you want to delete this Vishesh Sahyogi member?</p>
          {userName && (
            <div style={{ 
              background: '#fff2f0', 
              border: '1px solid #ffccc7', 
              padding: '8px 12px', 
              borderRadius: '6px',
              marginTop: '8px'
            }}>
              <Text strong style={{ color: '#cf1322' }}>Member to be deleted:</Text>
              <br />
              <Text>{userName}</Text>
            </div>
          )}
          <p style={{ color: '#8c8c8c', fontSize: '12px', marginTop: '8px' }}>
            ⚠️ This action cannot be undone.
          </p>
        </div>
      ),
      okText: 'Yes, Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      okButtonProps: {
        danger: true,
        style: { borderRadius: '6px' }
      },
      cancelButtonProps: {
        style: { borderRadius: '6px' }
      },
      onOk() {
        handleDelete(id);
      },
    });
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const { current, pageSize } = pagination;
    const { field, order } = sorter;
    const formattedOrder = order === 'ascend' ? 'asc' : 'desc';
    setSortField(field);
    setSortOrder(formattedOrder);
    setFilters(filters);
    history.push(`?page=${current}&limit=${pageSize}`);
    getVisheshSahyogiList(current, pageSize, field, formattedOrder, search, filters);
  };

  const handleLimitChange = value => {
    setLimit(value);
    const updatedQueryParams = new URLSearchParams(location.search);
    updatedQueryParams.set('limit', value);
    updatedQueryParams.set('page', 1);
    history.push(`?${updatedQueryParams.toString()}`);
    getVisheshSahyogiList(1, value);
  };

  const handleFilterChange = (field, value) => {
    const newFilters = {
      ...filters,
      [field]: value
    };
    setFilters(newFilters);
    const updatedQueryParams = new URLSearchParams(location.search);
    Object.keys(newFilters).forEach(key => {
      if (newFilters[key]) {
        updatedQueryParams.set(key, newFilters[key]);
      } else {
        updatedQueryParams.delete(key);
      }
    });
    history.push(`?${updatedQueryParams.toString()}`);
  };

  const handleSearch = () => {
    getVisheshSahyogiList(1, limit, sortField, sortOrder, search, filters);
  };

  const handleResetFilters = () => {
    const resetFilters = {
      name: '',
      phone_no: '',
      order_key: '',
      father_name: '',
      father_in_low: '',
      gotra: '',
      village: '',
      tehsil: '',
      district: '',
      occupation: '',
      occ_district: '',
      amount_pledge: '',
      alternative_no: '',
      committee: '',
      meeting_attendance: '',
      meeting_remark: '',
      meeting_date: '',
      dob: '',
      createdAt: '',
    };
    setFilters(resetFilters);
    setSearch('');
    const updatedQueryParams = new URLSearchParams(location.search);
    Object.keys(resetFilters).forEach(key => {
      updatedQueryParams.delete(key);
    });
    history.push(`?${updatedQueryParams.toString()}`);
    getVisheshSahyogiList(1, limit, sortField, sortOrder, '', resetFilters);
  };

  const handlePurnimaFormCheckboxChange = async (e) => {
    const isChecked = e.target.checked;
    setShowPurnimaMessageForm(isChecked);
    
    if (isChecked) {
      try {
        setLoading(true);
        await getLatestPurnimaSettingRecord();
      } catch (error) {
        notification.error({
          message: 'Error',
          description: 'Failed to load message settings',
          placement: 'topRight'
        });
      } finally {
        setLoading(false);
      }
    }
  };

  async function getLatestPurnimaSettingRecord() {
    try {
      const response = await axios.get(`${baseUrl}/purnima-message-setting/read`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        setPurnimaSettingRecord(response.data.result);
      } else {
        setPurnimaSettingRecord();
        notification.info({
          message: 'Info',
          description: response.data.message,
          placement: 'topRight'
        });
      }
    } catch (error) {
      notification.info({
        message: 'Info',
        description: error.response?.data?.message,
        placement: 'topRight'
      });
    }
  }

  const exportToExcel = async () => {
    try {
      setLoading(true);
      const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
      const searchParam = search ? `&search=${search}` : '';
      const filterParams = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&');
      const response = await axios.get(`${baseUrl}/vishesh_sahyogi/list?page=${1}&limit=all${sortParam}${searchParam}&${filterParams}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        const formattedData = response.data.result.map((user, index) => ({
          "Sr.No": index + 1,
          "Phone no": user.phone_no,
          "Order no": user.order_key,
          "Name": user.name,
          "Amount": user.amount_pledge,
          "Father Name": user.father_name,
          "Father In Law": user.father_in_low,
          "Gotra Name": user.gotra,
          "DOB": user.dob ? moment(user.dob).format('DD-MM-YYYY') : '-',
          "Village": user.village,
          "Tehsil": user.tehsil,
          "District": user.district,
          "Occupation": user.occupation,
          "Occupation District": user.occ_district,
          "Contribution Remark": user.inspiration_remark,
          "Alternative No": user.alternative_no,
          "Committee": user.committee,
          "Meeting Attendance": user.meeting_attendance,
          "Meeting Remark": user.meeting_remark,
          "Meeting Date": user.meeting_date ? moment(user.meeting_date).format('DD-MM-YYYY') : '-',
          "Entry Date": user.createdAt ? moment(user.createdAt).format('DD-MM-YYYY') : '-',
        }));

        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Vishesh-sahyogi-list");
        XLSX.writeFile(workbook, "Vishesh-sahyogi-List.xlsx");
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to export data',
        placement: 'topRight'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            headStyle={{ background: '#f8fafc', borderBottom: '1.5px solid #e2e8f0' }}
            title={
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <TeamOutlined style={{ color: '#fff', fontSize: '20px' }} />
                <Title level={3} style={{ margin: 0, color: '#fff' }}>
                  Vishesh Sahyogi
                </Title>
              </div>
            }
            extra={
              <Space size="middle">
                <Button
                  type="default"
                  icon={<FileExcelOutlined />}
                  onClick={() => setIsModalVisibleImportList(true)}
                  style={{ borderRadius: '6px' }}
                >
                  Import List
                </Button>
                {hasPermission('/vishesh-sahyogi', 'createPermission') && (
                  <Button
                    onClick={() => showDrawer()}
                    style={{
                      background: '#fff',
                      color: '#7a0000',
                      borderColor: '#fff',
                      borderRadius: '6px',
                      fontWeight: 600,
                      boxShadow: '0 2px 4px rgba(0,0,0,0.15)'
                    }}
                  >
                    Add Vishesh Sahyogi
                  </Button>
                )}
                {hasPermission('/vishesh-sahyogi', 'downloadPermission') && (
                  <Button
                    type="default"
                    icon={<FileExcelOutlined />}
                    onClick={exportToExcel}
                    style={{ borderRadius: '6px' }}
                  >
                    Export Excel
                  </Button>
                )}
              </Space>
            }
          >
            <div className="table-responsive">
              <Table
                columns={columns}
                loading={loading}
                scroll={{ x: 'max-content' }}
                bordered
                size="middle"
                title={() => (
                  <div style={{ marginBottom: '16px' }}>
                    <Row gutter={[16, 16]} align="middle">
                      <Col>
                        <Checkbox
                          checked={showPurnimaMessageForm}
                          onChange={handlePurnimaFormCheckboxChange}
                          style={{ 
                            transform: 'scale(1.1)',
                            marginRight: '8px'
                          }}
                        >
                          <Text strong style={{ fontSize: '13px' }}>
                            Show Vishesh Sahyogi Message Settings
                          </Text>
                        </Checkbox>
                      </Col>
                      
                      <Col>
                        <Button
                          icon={<FilterOutlined />}
                          onClick={() => setShowVisheshFilter(!showVisheshFilter)}
                          style={{
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                          }}
                        >
                          {showVisheshFilter ? 'Hide Filters' : 'Show Filters'}
                        </Button>
                      </Col>
                    </Row>

                    {/* Message Forms */}
                    {showPurnimaMessageForm && (
                      <div style={{ 
                        marginTop: '16px',
                        padding: '20px',
                        background: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e9ecef'
                      }}>
                        <Title level={4} style={{ marginBottom: '16px', color: '#7a0000' }}>
                          📅 Vishesh Sahyogi Message Settings
                        </Title>
                        <Row gutter={[16, 16]}>
                          <Col xs={24}>
                            {purnimaSettingRecord && purnimaSettingRecord?.purnimaMsgRecords?.length > 0 ? (
                              <AddMessage record={purnimaSettingRecord.purnimaMsgRecords[0]} />
                            ) : (
                              <AddMessage record={{}} />
                            )}
                          </Col>
                        </Row>
                      </div>
                    )}

                    {/* Filters */}
                    {showVisheshFilter && (
                      <div style={{
                        marginTop: '16px',
                        padding: '16px',
                        background: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e9ecef'
                      }}>
                        <Row gutter={[12, 12]}>
                          <Col span={6}>
                            <Input
                              placeholder="Search by phone"
                              value={filters.phone_no}
                              onChange={e => handleFilterChange('phone_no', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Order No"
                              value={filters.order_key}
                              onChange={e => handleFilterChange('order_key', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Search by name"
                              value={filters.name}
                              onChange={e => handleFilterChange('name', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Father name"
                              value={filters.father_name}
                              onChange={e => handleFilterChange('father_name', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Father In Law"
                              value={filters.father_in_low}
                              onChange={e => handleFilterChange('father_in_low', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Gotra"
                              value={filters.gotra}
                              onChange={e => handleFilterChange('gotra', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Village"
                              value={filters.village}
                              onChange={e => handleFilterChange('village', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Tehsil"
                              value={filters.tehsil}
                              onChange={e => handleFilterChange('tehsil', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="District"
                              value={filters.district}
                              onChange={e => handleFilterChange('district', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Occupation"
                              value={filters.occupation}
                              onChange={e => handleFilterChange('occupation', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Occ District"
                              value={filters.occ_district}
                              onChange={e => handleFilterChange('occ_district', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Amount"
                              value={filters.amount_pledge}
                              onChange={e => handleFilterChange('amount_pledge', e.target.value)}
                              style={{ borderRadius: '6px' }}
                              type="number"
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Alternative No"
                              value={filters.alternative_no}
                              onChange={e => handleFilterChange('alternative_no', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Committee"
                              value={filters.committee}
                              onChange={e => handleFilterChange('committee', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Meeting Attendance"
                              value={filters.meeting_attendance}
                              onChange={e => handleFilterChange('meeting_attendance', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Meeting Remark"
                              value={filters.meeting_remark}
                              onChange={e => handleFilterChange('meeting_remark', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <DatePicker
                              className="filter_dob"
                              format="DD-MM-YYYY"
                              value={filters.dob ? moment(filters.dob, 'DD-MM-YYYY') : null}
                              onChange={(date, dateString) => handleFilterChange('dob', dateString)}
                              placeholder="DOB Date"
                              style={{ width: '100%', borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <DatePicker
                              className="filter_dob"
                              format="DD-MM-YYYY"
                              value={filters.meeting_date ? moment(filters.meeting_date, 'DD-MM-YYYY') : null}
                              onChange={(date, dateString) => handleFilterChange('meeting_date', dateString)}
                              placeholder="Meeting Date"
                              style={{ width: '100%', borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <DatePicker
                              className="filter_dob"
                              format="DD-MM-YYYY"
                              value={filters.createdAt ? moment(filters.createdAt, 'DD-MM-YYYY') : null}
                              onChange={(date, dateString) => handleFilterChange('createdAt', dateString)}
                              placeholder="Entry Date"
                              style={{ width: '100%', borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={24}>
                            <Space>
                              <Button
                                icon={<SearchOutlined />}
                                onClick={handleSearch}
                                style={{ borderRadius: '6px', background: '#7a0000', borderColor: '#7a0000', color: '#fff' }}
                              >
                                Search
                              </Button>
                              <Button
                                icon={<ReloadOutlined />}
                                onClick={handleResetFilters}
                                style={{ borderRadius: '6px' }}
                              >
                                Reset All Filters
                              </Button>
                            </Space>
                          </Col>
                        </Row>
                      </div>
                    )}

                    <Row style={{ marginTop: '16px' }}>
                      <Col>
                        <Space align="center">
                          <Text strong>Records per page:</Text>
                          <Select
                            value={limit}
                            onChange={handleLimitChange}
                            style={{ width: 80, borderRadius: '6px' }}
                          >
                            <Option value={20}>20</Option>
                            <Option value={40}>40</Option>
                            <Option value={60}>60</Option>
                            <Option value={80}>80</Option>
                            <Option value={100}>100</Option>
                            <Option value={250}>250</Option>
                            <Option value={300}>300</Option>
                          </Select>
                        </Space>
                      </Col>
                    </Row>
                  </div>
                )}
                dataSource={visheshSahyogiList.map((user, index) => {
                  const isMatch = user.phone_no === user.user_phone_no;
                  
                  return {
                    key: (limit * (currentPage - 1)) + index + 1,
                    photo: (
                      <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Image
                          width={50}
                          height={50}
                          className="shape-avatar"
                          src={user.profile_photo ? user.profile_photo : userDummy}
                          style={{ 
                            borderRadius: '8px',
                            objectFit: 'cover',
                            border: '2px solid #f0f0f0'
                          }}
                          fallback={userDummy}
                        />
                      </div>
                    ),
                    phone_no: (
                      <div style={{ textAlign: 'center' }}>
                        <Tag
                          color={isMatch ? 'success' : 'default'}
                          style={{
                            borderRadius: '12px',
                            padding: '4px 12px',
                            fontWeight: '500'
                          }}
                        >
                          {user.phone_no}
                        </Tag>
                        {isMatch && (
                          <div style={{ fontSize: '10px', color: '#52c41a', marginTop: '2px' }}>
                            ✓ Verified
                          </div>
                        )}
                      </div>
                    ),
                    order_key: (
                      <div style={{ textAlign: 'center' }}>
                        <Tag color="blue" style={{ borderRadius: '12px', fontWeight: '500' }}>
                          #{user.order_key || '-'}
                        </Tag>
                      </div>
                    ),
                    name: (
                      <Text strong style={{ color: '#262626' }}>{user.name}</Text>
                    ),
                    father_name: (
                      <Text style={{ color: '#595959' }}>{user.father_name || '-'}</Text>
                    ),
                    father_in_low: (
                      <Text style={{ color: '#595959' }}>{user.father_in_low || '-'}</Text>
                    ),
                    gotra: (
                      <Text style={{ color: '#595959' }}>{user.gotra || '-'}</Text>
                    ),
                    amount_pledge: (
                      <Text strong style={{ color: '#7a0000' }}>
                        ₹{user.amount_pledge ? Number(user.amount_pledge).toLocaleString() : '0'}
                      </Text>
                    ),
                    dob: (
                      <Text>{user.dob ? moment(user.dob).format('DD MMM YYYY') : '-'}</Text>
                    ),
                    village: (
                      <Text style={{ color: '#595959' }}>{user.village || '-'}</Text>
                    ),
                    tehsil: (
                      <Text style={{ color: '#595959' }}>{user.tehsil || '-'}</Text>
                    ),
                    district: (
                      <Text style={{ color: '#595959' }}>{user.district || '-'}</Text>
                    ),
                    occupation: (
                      <Text style={{ color: '#595959' }}>{user.occupation || '-'}</Text>
                    ),
                    occ_district: (
                      <Text style={{ color: '#595959' }}>{user.occ_district || '-'}</Text>
                    ),
                    inspiration_remark: (
                      <Text style={{ color: '#595959' }}>{user.inspiration_remark || '-'}</Text>
                    ),
                    alternative_no: (
                      <Text style={{ color: '#595959' }}>{user.alternative_no || '-'}</Text>
                    ),
                    committee: (
                      <Text style={{ color: '#595959' }}>{user.committee || '-'}</Text>
                    ),
                    meeting_attendance: (
                      <Text style={{ color: '#595959' }}>{user.meeting_attendance || '-'}</Text>
                    ),
                    meeting_remark: (
                      <Text style={{ color: '#595959' }}>{user.meeting_remark || '-'}</Text>
                    ),
                    meeting_date: (
                      <Text>
                        {user.meeting_date && user.meeting_date !== "0000-00-00" 
                          ? moment(user.meeting_date).format('DD MMM YYYY') 
                          : '-'}
                      </Text>
                    ),
                    createdAt: (
                      <Text>
                        {user.createdAt && user.createdAt !== "0000-00-00" 
                          ? moment(user.createdAt).format('DD MMM YYYY') 
                          : '-'}
                      </Text>
                    ),
                    action: (
                      <Space size="small">
                        {hasPermission('/vishesh-sahyogi', 'editPermission') && (
                          <Button
                            size="small"
                            icon={<EditOutlined />}
                            onClick={() => showDrawer(user.id)}
                            style={{ borderRadius: '4px', background: '#7a0000', borderColor: '#7a0000', color: '#fff' }}
                          >
                            Edit
                          </Button>
                        )}
                        {hasPermission('/vishesh-sahyogi', 'deletePermission') && (
                          <Button
                            danger
                            size="small"
                            icon={<DeleteOutlined />}
                            onClick={() => showDeleteConfirm(user.id, user.name)}
                            style={{ borderRadius: '4px' }}
                          >
                            Delete
                          </Button>
                        )}
                      </Space>
                    )
                  };
                })}
                pagination={{
                  ...pagination,
                  showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} records`,
                  showSizeChanger: false,
                  style: { marginTop: '16px' }
                }}
                onChange={handleTableChange}
                className="ant-border-space"
                style={{
                  borderRadius: '8px',
                  overflow: 'hidden'
                }}
              />
            </div>
          </Card>
        </Col>
      </Row>

      {/* Enhanced Drawer for Add/Edit */}
      <Drawer
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {isUpdateMode ? <EditOutlined style={{ color: 'white', fontSize: '18px' }} /> : <TeamOutlined style={{ color: 'white', fontSize: '18px' }} />}
            </div>
            <div>
              <Title level={4} style={{ margin: 0, color: 'white' }}>
                {isUpdateMode ? 'Update Vishesh Sahyogi' : 'Add Vishesh Sahyogi'}
              </Title>
          
            </div>
          </div>
        }
        width={window.innerWidth > 768 ? 700 : '95%'}
        open={drawerVisible}
        onClose={closeDrawer}
        closable={false}
        bodyStyle={{
          padding: 0,
          background: '#f8f9fa'
        }}
        headerStyle={{
          background: '#7a0000',
          border: 'none'
        }}
        extra={
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={closeDrawer}
            style={{ color: 'white' }}
          />
        }
        destroyOnClose
      >
        <div style={{ height: '100%', padding: '24px' }}>
          <VisheshSahyogiForm 
            userId={currentUserId} 
            onRefreshData={onRefresh}
          />
        </div>
      </Drawer>

      {/* Import Modal */}
      <ImportListModal
        isVisible={isModalVisibleImportList}
        onClose={() => setIsModalVisibleImportList(false)}
        onSuccess={() => {
          setIsModalVisibleImportList(false);
          getVisheshSahyogiList();
        }}
      />

      {/* Image Modal */}
      <Modal
        open={isModalVisible}
        footer={null}
        onCancel={() => setIsModalVisible(false)}
        centered
      >
        <img
          src={currentImage}
          alt="Profile"
          style={{ width: '100%', borderRadius: '8px' }}
        />
      </Modal>
    </div>
  );
}

export default VisheshSahyogi;